<template>
  <div id="centered-container">
    <md-content class="md-elevation-3">
      <div class="title">
        <img src="/static/logo_azul.png" style="height: 30px" />
      </div>
      <div class="form">
        <md-field>
          <label>Nome Completo</label>
          <md-input v-model="accountant.username" autofocus />
        </md-field>

        <md-field>
          <label>E-mail</label>
          <md-input v-model="accountant.email" autofocus />
        </md-field>

        <md-field>
          <label>CNPJ</label>
          <md-input
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="accountant.identification"
            name="identification"
          />
        </md-field>

        <md-field>
          <label>Telefone</label>
          <md-input
            v-mask="['## #####-####']"
            v-model="accountant.phone"
            name="phone"
          />
        </md-field>

        <md-field md-has-password>
          <label>Senha</label>
          <md-input
            v-model="accountant.password"
            type="password"
            @keyup.enter="trigger"
          />
        </md-field>
        <div style="max-width: 300px">
          <password-strength-bar :password="accountant.password" />
        </div>
        <md-button
          class="md-raised btn-atualizar-mail"
          @click="createAccountant()"
          >Cadastrar
        </md-button>
      </div>
    </md-content>

    <div class="pos-rlt fix-padding-top-print padder-v-md">
      <div class="app-footer wrapper-sm">
        <div class="row pos-rlt text-center">
          <div class="div-img-footer"></div>
          <div class="col-md-12">
            <nav class="link-list list-inline-ui m-b-none pull-left w-full" />
            <small class="app-footer-copy m-t-xs pull-left w-full">
              Copyright © {{ dateAtual }} Zucchetti. Todos os direitos
              reservados
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-spinkit";
import moment from "moment";
import { http, httpLogin } from "../api/backend";
import PasswordStrengthBar from "../password/PasswordStrengthBar.vue";

export default {
  name: "NewAccountant",
  components: {
    Spinner,
    moment,
    PasswordStrengthBar
  },
  data() {
    return {
      dateAtual: moment().format("YYYY"),
      client: [],
      accountant: {
        username: "",
        password: "",
        email: "",
        identification: "",
        phone: ""
      }
    };
  },
  created() {
    this.getClient();
  },
  methods: {
    getClient() {
      http.post("application.get-client").then(response => {
        this.client = response.data;
      });
    },

    createAccountant() {
      if (
        !this.accountant.username ||
        !this.accountant.identification ||
        !this.accountant.password ||
        !this.accountant.phone
      ) {
        this.$toasted.show("Todos os campos são obrigatórios", {
          theme: "outline",
          position: "bottom-right",
          duration: 6000,
          type: "error",
          icon: "error_outline"
        });
        return;
      }

      if (!this.validEmail(this.accountant.email)) {
        this.$toasted.show("E-mail inválido verifique", {
          theme: "outline",
          position: "bottom-right",
          duration: 6000,
          type: "error",
          icon: "error_outline"
        });
        return;
      }
      this.createClientAccountant();
    },

    createClientAccountant() {
      httpLogin
        .post("application.signup-client", {
          username: this.accountant.username,
          email: this.accountant.email,
          termsAcceptance: true,
          identification: this.cleanMask(this.accountant.identification),
          password: this.accountant.password,
          paymentModeId: 24,
          phone: this.cleanMask(this.accountant.phone)
        })
        .then(() => {
          setTimeout(() => {
            this.$toasted.show("Cadastrado com sucesso, realize o login", {
              theme: "outline",
              position: "bottom-right",
              duration: 6000,
              type: "success",
              icon: "check_circle"
            });
          }, 100);
          this.$router.push({ path: "/" });
        })
        .catch(error => {
          const defaultMessage =
            "Não foi possível cadastrar o seu contador, entre em contato";
          const errorMessage =
            error.response &&
            error.response.data &&
            error.response.data.error_message
              ? `${defaultMessage} motivo: ${error.response.data.error_message}`
              : `${defaultMessage}.`;

          this.$toasted.show(errorMessage, {
            theme: "outline",
            position: "bottom-right",
            duration: 5000,
            type: "error",
            icon: "error_outline"
          });
        });
    },

    validEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    cleanMask(value) {
      return value.replace(/\^|~|\?|,|\*|\.|-|\/|/g, "");
    },

    formatDate(value) {
      return moment(String(value)).format("YYYY");
    }
  }
};
</script>
<style type="text/css">
#centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;
}
.title {
  text-align: center;
  margin-bottom: 30px;
  color: #1b8af1;
  font-size: 34px;
  font-weight: 300;
}
.form {
  margin-bottom: 60px;
}

.md-elevation-3 {
  z-index: 1;
  padding: 40px;
  margin: 40px;
  width: 100%;
  max-width: 400px;
  position: relative;
  border-radius: 5px;
  border: 1px solid transparent;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: all 0.5s;
}
.card {
  border-radius: 5px;
  border: 1px solid transparent;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  transition: all 0.5s;
}
.loading-overlay {
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-success {
  color: #fff;
  background-color: #44bb52;
  border-color: rgba(0, 0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/public/newaccountant/NewAccountant.vue